var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.001 11.614a8.76 8.76 0 0 0 5.431-2.541 8.76 8.76 0 0 0 2.54-5.431l.002-.001a8.76 8.76 0 0 0 2.542 5.432 8.76 8.76 0 0 0 5.427 2.54 8.76 8.76 0 0 0-5.43 2.54 8.76 8.76 0 0 0-2.54 5.43 8.76 8.76 0 0 0-2.54-5.427A8.76 8.76 0 0 0 0 11.616L0 11.615zM12.765 3.497a3.84 3.84 0 0 0 2.382-1.115A3.84 3.84 0 0 0 16.261 0h.001c.078.87.45 1.717 1.114 2.382a3.84 3.84 0 0 0 2.38 1.114 3.84 3.84 0 0 0-2.38 1.115 3.84 3.84 0 0 0-1.115 2.38 3.84 3.84 0 0 0-1.114-2.38 3.84 3.84 0 0 0-2.382-1.114"
  })));
};
export default SvgStar;